<template>
  <div class="home-page">
    <g-nav-bar></g-nav-bar>
    <g-banner></g-banner>
    <component :is="activePage"></component>
    <g-pwLogin v-if="showPwIframe"></g-pwLogin>

    <!-- 弹框 -->
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose">
      <div class="active-end">
        <button class="x" @click="handleClose"></button>
        <p>
          亲爱的刀友们：<br />《刀塔故事会》活动已于2020年9月18日23:59结束。<br />
          排名奖励已发放，请于“创作页/查看我的奖品”中查看。<br />实物奖品地址填写截止于
          2020年9月27日23:59，逾期则视为放弃。<br />感谢你们的参与与支持！
        </p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/utils/http'
import { MEMES2020 } from '../api/index'
import { Dialog } from 'element-ui'
import { getCookie, setCookie } from '@/utils/index'
import { mapMutations } from 'vuex'
import { DIALOG_OPTION } from '../store/mutation-types.js'
import Banner from '../components/Banner'
import HomeMain from '../components/HomeMain'
import WrittenMain from '../components/WrittenMain'
import PwLogin from '../components/dialog/PwLogin'
import NavBar from '../components/NavBar'
export default {
  name: 'Home',
  data() {
    return {
      dialogVisible: false,
    }
  },
  components: {
    gNavBar: NavBar,
    gPwLogin: PwLogin,
    gBanner: Banner,
    HomeMain,
    WrittenMain,
    elDialog: Dialog,
  },
  computed: {
    is_login() {
      return this.$store.state.base_info.is_logined
    },
    showPwIframe() {
      return this.$store.state.showPwIframe
    },
    activePage() {
      return this.$store.state.activePage
    },
  },
  mounted() {
    this.getPagePublicInfo() //获取页面数据
  },
  methods: {
    ...mapMutations([DIALOG_OPTION]),
    getPagePublicInfo() {
      //获取页面基础公共数据
      http
        .post(MEMES2020, {
          task: 'rank_list',
        })
        .then(data => {
          if (data.status == 'success') {
            let result = data.result
            this.$store.state.base_info = result
            //页面刷新跳转保证停留在用户操作的页面
            if (getCookie('active_page')) {
              if (this.is_login) {
                this.$store.state.activePage = getCookie('active_page')
              } else {
                this.$store.state.activePage = 'HomeMain'
                setCookie('active_page', 'HomeMain', 360)
              }
            } else {
              setCookie('active_page', 'HomeMain', 360)
            }

            if (this.is_login && this.activePage === 'HomeMain') {
              this.getMyUserInfo()
            }
          }
        })
    },
    getMyUserInfo() {
      http
        .post(MEMES2020, {
          task: 'my_info',
        })
        .then(data => {
          if (data.status == 'success') {
            let { user_info, user_awards } = data.result
            if (user_awards.length) {
              if (!localStorage.getItem('catPrize')) {
                //查看我的奖品
                this.$store.commit(DIALOG_OPTION, {
                  dialogTableVisible: true,
                  type: 'EVENTS_PRIZE',
                  data: {
                    title: '我的奖品',
                    prize: user_awards,
                  },
                })
                localStorage.setItem('catPrize', 'yes')
              }
            }
            this.$store.state.user_info = user_info
          }
        })
    },
    catPrize() {
      this.$store.state.dialog = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    cancel() {
      this.isactive = false
    },
  },
}
</script>
<style lang="scss" scoped>
.active-end {
  width: 730px;
  height: 338px;
  margin: 0 auto;
  position: relative;
  background-size: 100% 100%;
  background-image: url('https://img.dota2.com.cn/file/5f/00/5f0095a98ce0b4738372608125ee8b841596100336.png');
  .x {
    position: absolute;
    right: -18px;
    top: 26px;
    width: 40px;
    height: 40px;
    cursor: pointer;
    background-image: url('../assets/close.png');
  }
  p {
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translateY(-50%);
    color: #fff;
    font-size: 18px;
    line-height: 200%;
    padding-left: 106px;
  }
}
</style>
